import { boardsService } from "../Services";
import { State } from "./State";
export class Cell {
    get isChecked() {
        return this.checked.value;
    }
    constructor(number, checked) {
        this.number = number;
        this.checked = new State(checked);
    }
    check() {
        if (this.checked.value) {
            return;
        }
        this.checked.set(true);
    }
    checkOffline(boardId, gameId, playerId) {
        var _a;
        this.checked.set(this.checked.value ? false : true);
        const cells = localStorage.getItem('numbers') ? (_a = JSON.parse(localStorage.getItem('numbers'))) === null || _a === void 0 ? void 0 : _a.cells : [];
        if (cells) {
            for (const cell of cells) {
                if (cell) {
                    if (cell.number === this.number) {
                        cell.checked = this.checked;
                        localStorage.setItem('numbers', JSON.stringify({ cells: cells, date: new Date() }));
                        break;
                    }
                }
            }
            if (this.allChecked(cells)) {
                boardsService.checkBoard(boardId, gameId, playerId, cells);
            }
        }
    }
    allChecked(cells) {
        if (!cells)
            return false;
        if (cells.length < 1)
            return false;
        return cells.every((cell) => !cell || cell.checked.value == true);
    }
}
